export const BOLD = 'bold';
export const ITALIC = 'italic';
export const UNDERLINE = 'underline';

export type FontType = typeof BOLD | typeof ITALIC | typeof UNDERLINE;
export type TextWeightObjectType = { id: FontType; icon: string };
type TextWeightOptionsType = Record<FontType, TextWeightObjectType>;

export const textWeightOptions: TextWeightOptionsType = {
    [BOLD]: { id: BOLD, icon: 'text-bold' },
    [ITALIC]: { id: ITALIC, icon: 'text-italic' },
    [UNDERLINE]: { id: UNDERLINE, icon: 'text-underline' }
};

export const ALIGN_CENTER = 'center';
export const ALIGN_LEFT = 'left';
export const ALIGN_RIGHT = 'right';

export type AlignFontType = typeof ALIGN_CENTER | typeof ALIGN_LEFT | typeof ALIGN_RIGHT;
export type TextAlignObjectType = { id: AlignFontType; icon: string };
type TextAlignOptionsType = Record<AlignFontType, TextAlignObjectType>;

export const textAlignOptions: TextAlignOptionsType = {
    [ALIGN_LEFT]: { id: ALIGN_LEFT, icon: 'text-align-left' },
    [ALIGN_CENTER]: { id: ALIGN_CENTER, icon: 'text-align-center' },
    [ALIGN_RIGHT]: { id: ALIGN_RIGHT, icon: 'text-align-right' }
};
